








import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "GGWideGrid",
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  computed: {
    count() {
      return this.list.length;
    },
    shrinkedList() {
      return this.list.filter((_, index) => index < 12); // больше 12 нет смысла рендерить, они будут скрыты
    },
    largeCount() {
      if (this.count >= 12) {
        return 2;
      } else if (this.count >= 9) {
        return 1;
      } else {
        return 0;
      }
    },
  },
});
